define('v3/Pages/Settings/Services/ReadSpeaker.Backend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function ReadSpeakerBackend () {
		BackendBase.call(this);
	};

	ReadSpeakerBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(ReadSpeakerBackend.prototype, {
		getReadSpeakerSettings: function () {
			return this._getJsonApi('Settings/ClassPupilsReadSpeakerSettings');
		},
		updateReadSpeakerSettings: function (pupilReadSpeakerSettings) {
			return this._put('Settings/ClassPupilsReadSpeakerSettings', pupilReadSpeakerSettings);
		}
	});

	return new ReadSpeakerBackend();
});

